// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-45b404fc] {\n  width: 100%;\n}\n.table-wrapper .tableList[data-v-45b404fc] {\n  width: 100%;\n  table-layout: fixed;\n}\n.table-wrapper table[data-v-45b404fc],\n.table-wrapper th[data-v-45b404fc],\n.table-wrapper td[data-v-45b404fc] {\n  border: 1px solid black;\n  border-collapse: collapse;\n}\n.table-wrapper .tableList th[data-v-45b404fc],\n.table-wrapper .tableList td[data-v-45b404fc] {\n  padding: 10px;\n}", ""]);
// Exports
module.exports = exports;
